<ng-container *ngIf="ticketForm">
  <div class="page-container">
    <div class="row justify-content-center">
      <div class="ticket col-12">
        <ng-container *ngIf="supportCaseTypes.length > 0; else supportLoading">
          <div class="ticket-body">
            <!-- hide the form type tabs if Service Request form -->
            <ng-container
              *ngIf="formSupportType !== SUPPORT_TYPES.SERVICE_REQUEST">
              <div class="ticket-body-header">Select Request Type</div>
              <mat-button-toggle-group
                name="supportTypes"
                [value]="supportCaseTypes[0].id">
                <ng-container *ngFor="let supportCaseType of supportCaseTypes">
                  <mat-button-toggle
                    [value]="supportCaseType.id"
                    (change)="changeSupportType(supportCaseType.id)"
                    *appFeature="supportCaseType.id">
                    {{
                      supportCaseType.displayName
                        ? supportCaseType.displayName
                        : supportCaseType.name
                    }}
                  </mat-button-toggle>
                </ng-container>
                <!-- <mat-button-toggle
                  *ngFor="let supportCaseType of supportCaseTypes"
                  [value]="supportCaseType.id"
                  (change)="changeSupportType(supportCaseType.id)">
                  {{
                    supportCaseType.displayName
                      ? supportCaseType.displayName
                      : supportCaseType.name
                  }} 
                </mat-button-toggle>-->
              </mat-button-toggle-group>
            </ng-container>

            <form
              class="ticket-body-form"
              [formGroup]="ticketForm"
              (ngSubmit)="onSubmit()">
              <!-- Finance, Sustainability, Reporting  -->
              <div id="required-fields">
                Fields marked with an * are required fields.
              </div>
              <div
                class="row pb-5"
                [hidden]="formSupportType !== SUPPORT_TYPES.FINANCE">
                <div class="col-12 col-lg-6">
                  <mat-button-toggle-group
                    aria-label="Request Type"
                    class="cp"
                    class="flex-column flex-md-row"
                    [vertical]="false"
                    [formControl]="ticketForm.get('subType')">
                    <mat-button-toggle
                      [value]="CUSTOMER_SUB_CASE_TYPES.INVOICE_REQUEST">
                      Invoice Request
                    </mat-button-toggle>
                    <mat-button-toggle
                      [value]="CUSTOMER_SUB_CASE_TYPES.INVOICE_DISCREPANCY">
                      Invoice Discrepancy
                    </mat-button-toggle>
                    <mat-button-toggle
                      [value]="CUSTOMER_SUB_CASE_TYPES.MISSING_PO">
                      Missing PO
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </div>
              <!-- Reporting -->
              <div
                class="row pb-5"
                [hidden]="formSupportType !== SUPPORT_TYPES.REPORTING">
                <div class="col-lg-12 col-md-6">
                  <mat-button-toggle-group
                    aria-label="Request Type"
                    class="cp"
                    class="flex-column flex-md-row"
                    [vertical]="false"
                    [value]="REPORTING_SUB_CASE_TYPES.NEW_REPORT_REQUEST"
                    [formControl]="ticketForm.get('subTypeReporting')">
                    <mat-button-toggle
                      [value]="REPORTING_SUB_CASE_TYPES.NEW_REPORT_REQUEST">
                      Request New Report
                    </mat-button-toggle>
                    <mat-button-toggle
                      [value]="REPORTING_SUB_CASE_TYPES.MISSING_REPORT_REQUEST">
                      Missing Report
                    </mat-button-toggle>
                    <mat-button-toggle
                      [value]="
                        REPORTING_SUB_CASE_TYPES.QUESTIONS_ON_DATA_REPORT
                      ">
                      Questions on Data/Report
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </div>
              <div class="row">
                <mat-form-field class="col-12 col-lg-6" appearance="outline">
                  <mat-label>Site Name:</mat-label>
                  <input
                    type="text"
                    [placeholder]="
                      (isSitesLoading$ || isAllServiceSchedulesLoading$ | async)
                        ? 'Loading Sites...'
                        : 'Select Site Name'
                    "
                    aria-label="Site Name"
                    matInput
                    [formControl]="ticketForm.get('siteId')"
                    [readonly]="
                      isSitesLoading$ || isAllServiceSchedulesLoading$ | async
                    "
                    [matAutocomplete]="auto"
                    required />
                  <button
                    *ngIf="ticketForm.get('siteId')?.value"
                    mat-icon-button
                    matSuffix
                    aria-label="Clear"
                    (click)="
                      ticketForm.get('siteId').setValue('');
                      ticketForm.get('siteId').updateValueAndValidity()
                    ">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="displayFn">
                    <mat-option
                      *ngFor="let option of filteredOptions | async"
                      [value]="option">
                      {{ option.text }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <app-text-input
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="address"
                  label="Address"
                  placeholder="Address">
                </app-text-input>
              </div>
              <!-- Finance -->
              <div class="row">
                <app-text-input
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="name"
                  hidden
                  placeholder="Contact Name">
                </app-text-input>
                <app-text-input
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="email"
                  hidden
                  placeholder="Email Address">
                </app-text-input>
              </div>

              <div class="row">
                <app-text-input
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="phone"
                  type="tel"
                  placeholder="Enter Phone Number"
                  [readonly]="user.isPhoneValidated">
                </app-text-input>

                <app-multiple-email-input
                  *ngIf="isEmailNotificationEnabled"
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="additionalEmailAddress"
                  label="Additional Emails"
                  placeholder="Additional Emails"
                  maxLength="255">
                </app-multiple-email-input>

                <!-- Damage/Replace, Missed Service, Service Request -->
                <!-- hide if user hasn't selected a site yet -->
                <ng-container *ngIf="isExistingWasteStreamVisible()">
                  <app-dropdown-select
                    class="col-12 col-lg-6"
                    [parentForm]="ticketForm"
                    controlName="existingWasteStream"
                    labelText="Existing Waste Stream"
                    [options]="wasteStreamDropdownOptions">
                  </app-dropdown-select>
                </ng-container>

                <ng-container *ngIf="isNewWasteStreamVisible()">
                  <app-dropdown-select
                    class="col-12 col-lg-6"
                    [parentForm]="ticketForm"
                    controlName="newWasteStream"
                    labelText="New Waste Stream(s)"
                    [options]="onDemandProducts"
                    [placeholderText]="'Select New Waste Stream(s)'"
                    [isMultiple]="true"
                    [maxSelected]="3">
                  </app-dropdown-select>
                </ng-container>

                <ng-container *ngIf="isEquipmentTypeVisible()">
                  <app-dropdown-select
                    class="col-12 col-lg-6"
                    [parentForm]="ticketForm"
                    controlName="equipmentType"
                    labelText="Equipment Type"
                    [options]="
                      equipmentTypeDropdownOptions
                    "></app-dropdown-select>
                </ng-container>

                <ng-container *ngIf="isEquipmentSizeVisible()">
                  <app-dropdown-select
                    class="col-12 col-lg-6"
                    [parentForm]="ticketForm"
                    controlName="equipmentSize"
                    labelText="Equipment Size"
                    [options]="
                      equipmentSizeDropdownOptions
                    "></app-dropdown-select>
                </ng-container>
              </div>
              <!-- Missed Service -->
              <div
                class="row"
                [hidden]="formSupportType !== SUPPORT_TYPES.MISSED_SERVICE">
                <app-date-picker
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="missedDate"
                  type="date"
                  placeholder="mm/dd/yyyy"
                  label="Date Missed"
                  [maxDate]="todayDate">
                </app-date-picker>
              </div>

              <!-- Service Request - New Waste Stream "On Demand" -->
              <div class="row"></div>

              <!-- Service Request -->
              <div
                class="row"
                [hidden]="formSupportType !== SUPPORT_TYPES.SERVICE_REQUEST">
                <!-- Service Request - New Waste Stream "On Demand" -->
                <app-date-picker
                  [hidden]="
                    ticketForm.controls.existingWasteStream.value !== 'Other'
                  "
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="requestedDropOffDate"
                  type="date"
                  placeholder="mm/dd/yyyy"
                  label="Requested Drop Off Date"
                  [minDate]="todayDate">
                </app-date-picker>
                <!-- Service Request - For both New and Existing Waste Streams -->
                <!-- For "On Demand" the user has to pick a requestedDropOffDate first -->
                <!-- "On Demand" or "On Call" -->
                <app-date-picker
                  [hidden]="
                    ticketForm.controls.existingWasteStream.value === 'Other' &&
                    !ticketForm.controls.requestedDropOffDate.value
                  "
                  class="col-12 col-lg-6"
                  [parentForm]="ticketForm"
                  controlName="requestedPickupDate"
                  type="date"
                  placeholder="mm/dd/yyyy"
                  label="Requested Pickup Date"
                  [minDate]="
                    ticketForm.controls.existingWasteStream.value === 'Other'
                      ? ticketForm.controls.requestedDropOffDate.value
                      : todayDate
                  ">
                </app-date-picker>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <app-file-upload
                    [showValidationError]="
                      ticketForm?.controls.fileUpload.touched &&
                      ticketForm?.controls.fileUpload.invalid
                    "
                    [label]="'Upload Image'"
                    [isRequired]="
                      ticketForm.controls.fileUpload.errors?.required
                    "
                    [placeholder]="'Drag and drop an image file here or click'"
                    [maxFiles]="5"
                    (onFileChange)="setFiles($event)">
                  </app-file-upload>
                </div>
                <div class="col">
                  <app-text-area-input
                    [parentForm]="ticketForm"
                    [controlName]="'description'"
                    [placeholder]="'Enter Description'">
                  </app-text-area-input>
                </div>
              </div>

              <div
                class="row submit-container {{
                  disableSubmit ? ' disable-submit' : ''
                }}">
                <div class="col-12 d-md-flex align-items-center">
                  <app-submit-input
                    [parentForm]="ticketForm"
                    [disabled]="this.ticketForm.invalid"
                    controlName="submit"
                    value="Submit">
                  </app-submit-input>
                  <a id="cancel-link" href="#" [routerLink]="['/dashboard']">
                    Cancel
                  </a>
                </div>
              </div>
            </form>
          </div>
        </ng-container>
        <ng-template #supportLoading>
          <app-form-loading-visual></app-form-loading-visual>
        </ng-template>
      </div>
    </div>
  </div>
</ng-container>
